import { LinePoint } from '@/types/reactions';
import { UsePointToProjectionResult } from '@/utils/map/usePointToProjection';
import { Feature } from 'ol';
import { LineString, SimpleGeometry } from 'ol/geom';
import Style from 'ol/style/Style';
import Fill from 'ol/style/Fill';
import { LINE_COLOR, LINE_WIDTH } from '@/constants/canvas';
import Stroke from 'ol/style/Stroke';
import { addAlphaToHexString } from '@/utils/convert/addAlphaToHexString';
import { INACTIVE_HIGHLIGHT_REACTION_OPACITY } from '@/components/Map/MapViewer/MapViewer.constants';

export const getLineFeature = (
  linePoints: LinePoint,
  pointToProjection: UsePointToProjectionResult,
  isActive: boolean = true,
): Feature<SimpleGeometry> => {
  const points = linePoints.map(pointToProjection);

  const feature = new Feature({
    geometry: new LineString(points),
  });
  const style = new Style({
    fill: new Fill({
      color: isActive
        ? LINE_COLOR
        : addAlphaToHexString(LINE_COLOR, INACTIVE_HIGHLIGHT_REACTION_OPACITY),
    }),
    stroke: new Stroke({
      color: isActive
        ? LINE_COLOR
        : addAlphaToHexString(LINE_COLOR, INACTIVE_HIGHLIGHT_REACTION_OPACITY),
      width: LINE_WIDTH,
    }),
  });
  feature.setStyle(style);
  return feature;
};
